export function isEmpty(text) {
    if (typeOf(text) === 'string') {
        return !text || !text.trim();
    } else {
        return !text;
    }

}

export function isValidEmail(email) {
    const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return re.test(email);
}

export function typeOf(obj) {
    return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase();
}

export function isValidBetweenMonths(text) {
    const pattern = /^([1-9]|1[1-2])-([1-9]|1[1-2])$/;
    return text.match(pattern);
}